import { styled } from "@mui/material"
import type { RefObject } from "react"
import { useEffect, useRef } from "react"
import type { MapRef } from "react-map-gl/mapbox"

const Root = styled("div")({
  width: "100%",
  height: "100%",
  position: "relative",
})

interface ResizableMapContainerProps {
  mapRef: RefObject<MapRef | null>
  children: React.ReactNode
  className?: string
}

export const ResizableMapContainer = ({
  mapRef,
  children,
  className,
}: ResizableMapContainerProps) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new ResizeObserver(() => mapRef.current?.resize())
    observer.observe(el)
    return () => observer.disconnect()
  }, [mapRef])

  return (
    <Root ref={ref} className={className}>
      {children}
    </Root>
  )
}
